import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Home, MessageSquare, Newspaper, FileText, Book } from 'lucide-react';

/**
 * A mobile bottom navigation bar with direct HTML links for maximum compatibility.
 * Uses regular anchor tags to ensure maximum device compatibility across all mobile browsers.
 */
const MobileNavigation = () => {
  // Get current path to determine active state
  const location = useLocation();
  
  // Log when component renders
  useEffect(() => {
    console.log('[MobileNavigation] Component mounted');
    console.log('[MobileNavigation] Current location:', location.pathname);
    
    // Force re-render on mount to ensure links are properly created
    const navLinks = document.querySelectorAll('#mobile-nav a');
    console.log('[MobileNavigation] Found nav links:', navLinks.length);
    
    // Add explicit click handlers to each link
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        console.log('[MobileNavigation] Link clicked:', link.getAttribute('href'));
      });
    });
    
    return () => console.log('[MobileNavigation] Component unmounted');
  }, [location.pathname]);
  
  // Check if a path is active
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  
  // Styling for active and inactive states
  const baseStyles = "flex flex-col items-center justify-center w-1/5 py-1"; 
  const activeStyles = `${baseStyles} text-slate-900 font-medium`;
  const inactiveStyles = `${baseStyles} text-gray-500`;
  
  console.log('[MobileNavigation] Rendering with current path:', location.pathname);
  
  return (
    <nav 
      id="mobile-nav"
      className="fixed bottom-0 left-0 w-full h-16 bg-white border-t border-gray-200 shadow-md z-50 sm:hidden"
      style={{ touchAction: 'manipulation' }}
      aria-label="Mobile navigation"
    >
      <div className="flex justify-between h-full w-full">
        {/* Using plain anchor tags for absolute maximum compatibility */}
        <a 
          href="/"
          className={isActive('/') ? activeStyles : inactiveStyles}
          style={{ textDecoration: 'none' }}
          onClick={() => console.log('[MobileNavigation] Home clicked')}
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <Home size={24} strokeWidth={2} />
          </div>
          <span className="text-xs">Home</span>
        </a>
        
        <a 
          href="/q/"
          className={isActive('/q') ? activeStyles : inactiveStyles}
          style={{ textDecoration: 'none' }}
          onClick={() => console.log('[MobileNavigation] Claims clicked')}
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <MessageSquare size={24} strokeWidth={2} />
          </div>
          <span className="text-xs">Claims</span>
        </a>
        
        <a 
          href="/a/"
          className={isActive('/a') ? activeStyles : inactiveStyles}
          style={{ textDecoration: 'none' }}
          onClick={() => console.log('[MobileNavigation] Articles clicked')}
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <Newspaper size={24} strokeWidth={2} />
          </div>
          <span className="text-xs">Articles</span>
        </a>
        
        <a 
          href="/p/"
          className={isActive('/p') ? activeStyles : inactiveStyles} 
          style={{ textDecoration: 'none' }}
          onClick={() => console.log('[MobileNavigation] Policies clicked')}
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <FileText size={24} strokeWidth={2} />
          </div>
          <span className="text-xs">Policies</span>
        </a>
        
        <a 
          href="/o/"
          className={isActive('/o') ? activeStyles : inactiveStyles}
          style={{ textDecoration: 'none' }}
          onClick={() => console.log('[MobileNavigation] Opinions clicked')}
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <Book size={24} strokeWidth={2} />
          </div>
          <span className="text-xs">Opinions</span>
        </a>
      </div>
    </nav>
  );
};

export default MobileNavigation;